<template>
  <div class="edit_page">
    <div class="header">
        <i class="icon_fanhui" @click="goBack"></i>
        <p>{{ title }}</p>
    </div>
    <div class="input_area">
        <template v-if="type == 'name'">
            <input type="text" class="input" v-model.trim="name" placeholder="请填写名字">
        </template>
        <template v-if="type == 'pwd'">
            <input type="password" class="input" v-model.trim="newpwd"  @input="onInput" max-length="16" min-length="6" placeholder="请填6-16位新密码">
            <input type="password" class="input bt" v-model.trim="confirmPwd"  @input="onInput" max-length="16" min-length="6" placeholder="再次确认新密码">
        </template>
        <template v-if="type == 'feedback'">
            <textarea  class="textarea" v-model.trim="feedback" @input="descInput" max-length="200" placeholder="输入反馈内容"></textarea>
            <div class="tips">还可以输入{{200-feedback.length}}</div>
        </template>
    </div>
    <div class="btn" :class="name||(newpwd.length>5&& confirmPwd.length>5)|| feedback ?'active':''" @click="submit">
        <span>确定</span>
    </div>
  </div>
</template>

<script>
let Base64 = require('js-base64').Base64;
export default {
    data(){
        return{
            type:this.$route.params.type,
            title:'',
            name:'',
            newpwd:'',
            confirmPwd:'',
            feedback:'',

        }
    },
    created(){
        if(this.type=='name'){
            this.title="修改姓名"
        }else if(this.type == 'pwd'){
            this.title = "修改密码"
        } else if (this.type == 'feedback') {
            this.title = "建议反馈"
        }
    },
    methods:{
        goBack(){
            this.$router.go(-1)
        },
        submit(){
            if(this.name || (this.newpwd.length >5 && this.confirmPwd.length >5) || this.feedback){
                if(this.type == 'name'){
                    console.log('修改姓名')
                    layer.open({ type: 2, shadeClose: false });
                    this.$http.post(API_URL_BASE_API + '/user/edit_user/',{
                        real_name:this.name
                    }).then(res => {
                       layer.closeAll()
                       if(res.data.response=='ok'){
                        let localUserInfo=JSON.parse(localStorage.getItem('info'))
                        localUserInfo.real_name= this.name
                        localStorage.setItem('info',JSON.stringify(localUserInfo))
                            layer.tips(res.data.message)
                             setTimeout(() => {
                                this.$router.replace('/mine')
                            }, 300)
                       }
                    })
                }
                if (this.type == 'pwd') {
                    console.log('修改密码')
                    if(this.newpwd!==this.confirmPwd){
                        layer.tips('两次密码不一致')
                        return
                    }
                    layer.open({ type: 2, shadeClose: false });
                    this.$http.post(API_URL_BASE_API + '/account/edit_pwd/', {
                        password: Base64.encode(this.confirmPwd)
                    }).then(res => {
                        layer.closeAll()
                        if (res.data.response == 'ok') {
                            layer.tips(res.data.message)
                             setTimeout(() => {
                                this.$router.replace('/mine')
                            }, 300)
                        }
                    })
                }
                if (this.type == 'feedback') {
                    console.log('建议反馈')
                    layer.open({ type: 2, shadeClose: false });
                    this.$http.post(API_URL_BASE_API + '/account/add_suggestion/', {
                        content: this.feedback,
                        login_type:5
                    }).then(res => {
                        layer.closeAll()
                        if (res.data.response == 'ok') {
                            layer.tips(res.data.message)
                            setTimeout(()=>{
                                this.$router.replace('/mine')
                            },300)
                        }
                    })
                }
            }else{
                return
            }
        },
        onInput () {
            this.newpwd = this.newpwd.slice(0, 16)
            this.confirmPwd = this.confirmPwd.slice(0, 16)
        },
         //输入时触发
            descInput () {
                if ((200 - this.feedback.length) < 0) {
                    this.feedback = this.feedback.substring(0, 200)
                }
            },
    }
}
</script>

<style lang="scss" scoped>
.edit_page{
    padding-top: 96px/$ppr;
}
.header {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 8;
    height: $h-header;
    line-height: $h-header;
    color: #fff;
    font-size: 34px / $ppr;
    text-align: center;
    background: #5e89ef;

    .icon_fanhui {
        display: block;
        width: 76px / $ppr;
        height: $h-header;
        background-image: url("./img/back.png");
        background-position: center;
        background-size: 18px / $ppr 34px / $ppr;
        background-repeat: no-repeat;
        position: absolute;
        top: 0;
        left: 0;
        cursor: pointer;
    }
}
.input_area{
   
    margin: 20px/$ppr 0;
    .input{
        border: 0;
         background:#fff;
        width: 100%;
        padding:28px/$ppr 20px/$ppr ;
        box-sizing: border-box;
        font-size: 28px/$ppr;
        color: #999;
    }
    .textarea{
        min-height: 400px/$ppr;
        background:#fff;
        padding: 20px/$ppr;
        width: 100%;
        display: block;
        box-sizing: border-box;
        border: 0;
        font-size: 28px/$ppr;
    }
    .bt{
        border-top: 1px/$ppr solid #eee;
    }
}
.btn{
        margin:100px/$ppr 32px/$ppr;
        background:#DCDCDC;
        height: 96px/$ppr;
        line-height: 96px/$ppr;
        color: #999;
        border-radius: 96px/$ppr;
        text-align: center;
        font-size: 28px/$ppr;
        &.active{
            background:#5e89ef;
            color: #fff;
        }
    }
    input::-webkit-input-placeholder{
            color:#b1b1b1;
        }
.tips{
    text-align: right;
    color: #333;
    font-size: 26px/$ppr;
    padding: 20px/$ppr;
}
</style>